<template>
    <v-layout>
      <v-row no-gutters >
        <v-col v-if="summaryView==='regular'">
          <table class="text-left person-info">
            <tbody>
            <tr>
              <td>Manager</td>
              <td><strong>&nbsp;{{ this.summary.manager || "No Data" }}</strong></td>
            </tr>
            <tr>
              <td>Supervisor</td>
              <td><strong>&nbsp;{{ this.summary.supervisor || "No Data" }} </strong></td>
            </tr>
            <tr>
              <td>Travelled</td>
              <td><strong>&nbsp;{{ this.summary.travelled ? this.summary.travelled + " Miles" : "No Data"}}</strong></td>
            </tr>
            <tr>
              <td>Travel Time</td>
              <td><strong>&nbsp;{{ this.summary.travelTime || "No Data" }}</strong></td>
            </tr>
            <tr>
              <td>GPS Points</td>
              <td><strong>&nbsp;{{ this.summary.gpsPoints || "No Data" }}</strong></td>
            </tr>
            <tr>
              <td>Day Start</td>
              <td><strong>&nbsp;{{ this.summary.dayStart || "No Data" }}</strong></td>
            </tr>
            <tr>
              <td>Day End</td>
              <td><strong>&nbsp;{{ this.summary.dayEnd || "No Data" }}</strong></td>
            </tr>
            </tbody>
          </table>
        </v-col>
        <v-col v-if="summaryView==='phone'">
					<table class="text-left person-info">
            <tbody>
						<tr>
              <td>Manager</td>
              <td><strong>&nbsp;{{ this.summary.manager || "No Data" }}</strong></td>
							<td></td>
            </tr>
            <tr>
              <td ng-if="true">Supervisor</td>
              <td ><strong>&nbsp;{{ this.summary.supervisor || "No Data" }} </strong></td>
							<td></td>
            </tr>
						<tr>
              <td><label class="label label-primary"></label></td>
              <td>
                &nbsp;<label class="label label-primary laptop">Laptop</label>
              </td>
              <td>
                &nbsp;<label class="label label-primary phone">Phone</label>
              </td>
            </tr>
            <tr>
              <td>Travelled</td>
							<td><strong>&nbsp;{{ this.summary.laptopTravelled ?  this.summary.laptopTravelled + " Miles" : "No Data"}}</strong></td>
							<td><strong>&nbsp;{{ this.summary.phoneTravelled ?  this.summary.phoneTravelled + " Miles" : "No Data"}}</strong></td>
            </tr>
            <tr>
              <td>Travel Time</td>
              <td><strong>&nbsp;{{ this.summary.laptopTravelTime || "No Data" }}</strong></td>
              <td><strong>&nbsp;{{ this.summary.phoneTravelTime || "No Data" }}</strong></td>
            </tr>
            <tr>
              <td>GPS Points</td>
              <td><strong>&nbsp;{{ this.summary.laptopGpsPoints || "No Data" }}</strong></td>
              <td><strong>&nbsp;{{ this.summary.phoneGpsPoints || "No Data" }}</strong></td>
            </tr>
            <tr>
              <td>Day Start</td>
              <td ng-if="InterviewerDaySummary.PointsLaptop"><strong>
                &nbsp;{{ this.summary.laptopDayStart|| "No Data" }}
								</strong>
              </td>
							<td ng-if="InterviewerDaySummary.PointsLaptop"><strong>
                &nbsp;{{ this.summary.phoneDayStart || "No Data" }}
								</strong>
              </td>
            </tr>
            <tr>
              <td>Day End</td>
              <td ng-if="InterviewerDaySummary.PointsLaptop"><strong>
                &nbsp;{{ this.summary.laptopDayEnd || "No Data" }}
								</strong>
              </td>
							<td ng-if="InterviewerDaySummary.PointsLaptop"><strong>
                &nbsp;{{  this.summary.phoneDayEnd || "No Data" }}
								</strong>
              </td>
            </tr>
            </tbody>
          </table>
        </v-col>
				<v-col v-if="summaryView==='lastRecieved'">
					<h4>Last Received UPS Track</h4>
					<table class="text-left person-info">
            <tbody>
						<tr>
							<td>Device</td>
							<td><strong>&nbsp;{{ gpsTrackInfo.device || "No Data" }}</strong></td>
						</tr>
						<tr>
							<td>Source</td>
							<td><strong>&nbsp;{{ gpsTrackInfo.source || "No Data" }}</strong></td>
						</tr>
						<tr>
							<td>Lat</td>
							<td><strong>&nbsp;{{ gpsTrackInfo.lat }} </strong></td>
						</tr>
						<tr>
							<td>Lon</td>
							<td><strong>&nbsp;{{ gpsTrackInfo.lon }}</strong></td>
						</tr>
						<tr>
							<td>Date and Time</td>
							<td><strong>&nbsp;{{ gpsTrackInfo.date || "No Data" }}</strong></td>
						</tr>
            </tbody>
					</table>
        </v-col>
      </v-row>
    </v-layout>
</template>

<script>
import { clusterService } from "@/services/cluster.service.js";
import { trackService } from "@/services/track.services.js";
import { STORE_CONSTANTS } from "../common/store.constants";

export default {
  name: "InterviewerDaySummaryTable",
  data: () => ({
    STORE_CONSTANTS,
    number: "111-111-1111",
    email: "email@email.com",
    summary: {
      manager: null,
      supervisor: null,
      travelled: null,
      travelTime: null,
      gpsPoints: null,
      dayStart: null,
      dayEnd: null,
      laptopTravelled: null,
      laptopTravelTime: null,
      laptopGpsPoints: null,
      laptopDayStart: null,
      laptopDayEnd: null,
      phoneTravelled: null,
      phoneTravelTime: null,
      phoneGpsPoints: null,
      phoneDayStart: null,
      phoneDayEnd: null
    },
    gpsTrackInfo: {
      device: null,
      source: null,
      lat: null,
      lon: null,
      date: null
    }
  }),
  props: {
    criteria: Object,
		summaryView: String,
		lastReceivedC: Object
  },
  watch: {
    criteria: function (newValue, oldValue) {
      if (newValue !== oldValue) {
        this.loadInterviewer(newValue);
      }
    },
		lastReceivedC: function (newValue, oldValue) {
      if (newValue !== oldValue) {
        this.getStaffLastReceivedGpsTrackMethod(newValue);
      }
    }
  },
  methods: {
    loadInterviewer (criteria) {
      const me = this;
			// console.log("summary loadInterviewer criteria: ", criteria);
      if(!criteria) {
        me.setInterviewerInfoEmpty();
        return;
      }

      // get the daily task summary for the selected FI
      me.$store.dispatch(me.STORE_CONSTANTS.DAILY_TASKS.ACTIONS.WITH_NAMESPACE.GET_STAFF_DAILY_SUMMARY, criteria).then((results) => {
        me.summary = results.summary;
      })
      .catch((err) => {
        console.log("loadInterviewer loader error:")
        console.log(err);
      });
    },
		getStaffLastReceivedGpsTrackMethod (criteria) {
      const me = this;
			this.userId = criteria.id

      // get the info for the last GPS track data received for the selected FI
      me.$store.dispatch(me.STORE_CONSTANTS.DAILY_TASKS.ACTIONS.WITH_NAMESPACE.GET_STAFF_DAILY_LAST_GPS_TRACK, criteria).then((results) => {
        me.gpsTrackInfo = results.gpsTrackInfo;
      })
      .catch((err) => {
        console.log("getStaffDailyLastGpsTrack loader error:")
        console.log(err);
      });
    },
    setInterviewerInfoEmpty() {
      this.summary = {
        manager: null,
        supervisor: null,
        travelled: null,
        travelTime: null,
        gpsPoints: null,
        dayStart: null,
        dayEnd: null,
        laptopTravelled: null,
        laptopTravelTime: null,
        laptopGpsPoints: null,
        laptopDayStart: null,
        laptopDayEnd: null,
        phoneTravelled: null,
        phoneTravelTime: null,
        phoneGpsPoints: null,
        phoneDayStart: null,
        phoneDayEnd: null
      };
    }
  }
};
</script>

<style scoped>
.phone {
  color: white;
  background-color: #e77504;
  display: inline;
  padding: 0.2em 0.6em 0.3em;
  font-size: 75%;
  font-weight: 700;
  line-height: 1;
  color: #fff;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: 0.25em;
}
.laptop {
  color: white;
  background-color: #06a2f9;
  display: inline;
  padding: 0.2em 0.6em 0.3em;
  font-size: 75%;
  font-weight: 700;
  line-height: 1;
  color: #fff;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: 0.25em;
}
tr:nth-child(odd) {
  /* background-color: lightblue; */
	background-color: rgba(21, 102, 124, 0.2);
}
table {
	width: 100%
}
.person-info {
  font-size: 15px;
	color: black;
}
</style>
